type EmployeePayrollIdentity = {
  id: string;
  currentEmploymentId?: number | null;
  previousEmploymentId?: number | null;
  isIssuedP45?: boolean | null;
};

/** P45 leaves a fresh current employment ready for rehire; display the one that ended. */
export const getEmployeePayrollId = (
  employee: EmployeePayrollIdentity,
): string => {
  const employmentId = employee.isIssuedP45
    ? employee.previousEmploymentId
    : employee.currentEmploymentId;
  if (employmentId) return `${employee.id}-${employmentId}`;
  return employee.isIssuedP45 ? '' : employee.id;
};
